import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { PulseLoader } from 'react-spinners';
import useModuleAccess from '../hooks/useModuleAccess';

const API_URL = process.env.REACT_APP_API_URL;

const SoConverter = () => {
    const { canCreate } = useModuleAccess("so_converter");
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // Map client selection to companyType
    const getCompanyType = (clientValue) => {
        const mapping = {
            '1': 'lucas-tvs',
            '2': 'grindwell-norton',
            '3': 'matrix',
            '4': 'xomox-company'
        };
        return mapping[clientValue] || '';
    };

    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
        setSelectedFile(null);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file type
            if (file.type !== 'application/pdf') {
                toast.error('Please upload a PDF file');
                event.target.value = '';
                return;
            }
            setSelectedFile(file);
        }
    };

    // Convert PDF file to base64
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // Remove data:application/pdf;base64, prefix
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedClient || !selectedFile) {
            toast.error('Please select a client and upload a PDF file');
            return;
        }

        setIsLoading(true);

        try {
            // Convert PDF to base64
            const pdfBase64 = await fileToBase64(selectedFile);
            const companyType = getCompanyType(selectedClient);

            // Make API call
            const payload = {
                pdfBase64: pdfBase64,
                companyType: companyType
            };

            const response = await axios.post(API_URL, payload);

            // Parse the response - handle both string and object responses
            let responseData = response.data;
            if (typeof responseData === 'string') {
                try {
                    responseData = JSON.parse(responseData);
                } catch (parseError) {
                    responseData = response.data;
                }
            }

            // Check if API call was successful
            if (responseData.success === true && responseData.data) {
                // Navigate to SoValidate with response data
                navigate('/soValidate', { 
                    state: { 
                        responseData: responseData,
                        itemCount: responseData.itemCount || 0
                    } 
                });
            } else {
                toast.error(responseData.message || "Failed to process PDF");
            }
        } catch (error) {
            console.error("PDF conversion error:", error);
            if (error.response && error.response.data) {
                const errorData = typeof error.response.data === 'string' 
                    ? JSON.parse(error.response.data) 
                    : error.response.data;
                toast.error(errorData.message || "Error processing PDF");
            } else {
                toast.error("Network error. Please try again.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">So Converter</h1>
                        </div>
                        <div className="col-sm-6 txt_rgt">
                            {canCreate && (
                                <Link to="/sodata" className="btn btn-blue">Add</Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="frmwdth_cntr_640">
                                <div className="col-lg-12">
                                    <div className="card card-primary card-outline">

                                        <form className="form-horizontal" onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group row">
                                                    <label className="col-12 col-md-3 col-form-label">Choose Client</label>
                                                    <div className="col-12 col-md-8 mb-3 mb-md-0">
                                                        <select
                                                            className="form-control"
                                                            id="client"
                                                            value={selectedClient}
                                                            onChange={handleClientChange}
                                                        >
                                                            <option value="">--Select--</option>
                                                            <option value="1">Lucas TVS Limited</option>
                                                            <option value="2">Grindwell Norton Limited</option>
                                                            <option value="3">Sanmar Matrix Metal Limited</option>
                                                            <option value="4">Xomax Sanmar</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-12 col-md-3 col-form-label">Upload SO PDF</label>
                                                    <div className="col-12 col-md-8 mb-3 mb-md-0">
                                                        <div className="custom-file">
                                                            <input
                                                                type="file"
                                                                className="custom-file-input"
                                                                id="soPDF"
                                                                accept="application/pdf"
                                                                disabled={!selectedClient}
                                                                onChange={handleFileChange}
                                                            />
                                                            <label className="custom-file-label" htmlFor="soPDF">
                                                                {selectedFile ? selectedFile.name : 'Choose file'}
                                                            </label>
                                                        </div>
                                                        {!selectedClient && (
                                                            <small className="form-text text-muted">
                                                                Select a client to enable PDF upload.
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                                {/*Show Member Type only when Member is chosen*/}
                                                <div id="hidden_div" style={{ display: 'none' }}>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-3 col-form-label">Member Type</label>
                                                        <div className="col-12 col-md-8 mb-3 mb-md-0">
                                                            <select className="form-control">
                                                                <option value>--Select--</option>
                                                                <option value>Free</option>
                                                                <option value>Premium</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /.card-body */}
                                            <div className="card-footer text-center">
                                                {isLoading ? (
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <PulseLoader color="#007bff" size={10} />
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className="btn btn-blue"
                                                        disabled={!selectedClient || !selectedFile || isLoading}
                                                    >
                                                        Upload
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SoConverter